export const LOGO_MONACO = '/logo-monaco.webp';
export const HOTEL_ICON = '/hotel-icon.png';
